export let PIPELINE_SHOW_NOTES_BASE_PATH =
  'pipeline/planning/courses/show-notes'

export let ANCC_TARGET_AUDIENCES = [
  'Registered Nurse',
  'Paramedic',
  'EMT',
  'Respiratory Therapist',
  'Advanced Practice Nurse',
  'Other',
]

export let ANCC_EDUCATIONAL_NEEDS_OPTIONS = ['Knowledge', 'Skill', 'Practice']

export let CAPCE_CLASS_TYPES = [
  'ARV',
  'Cardiac',
  'Critical Care',
  'Education',
  'Medical',
  'OBGYN',
  'Operations',
  'Trauma',
  'Pediatrics',
  'Other',
]

export let CAPCE_TOPIC_AREAS = [
  'Abdominal Emergencies',
  'Abuse',
  'ACLS',
  'Active Shooter',
  'Acute Coronary Syndromes',
  'Adult Respiratory Emergencies',
  'Advanced Airway',
  'AEMT Refresher',
  'Aeromedical Transport',
  'Allergy and Anaphylaxis',
  'ALS',
  'Altered Mental Status',
  'Ambulance Safety',
  'AMLS',
  'Anatomy and Physiology',
  'APLS',
  'Assessment',
  'Asthma',
  'At Risk Populations',
  'Autism',
  'Basic Airway',
  'Blood Borne Pathogens',
  'BLS',
  'Burns',
  'Capnography',
  'Cardiology',
  'CBRNE',
  'Cervical Injuries',
  'Chest Injuries',
  'CHF',
  'CNS Injury',
  'Communications',
  'Community Paramedicine',
  'Congenital Defects',
  'COPD',
  'Corona Virus',
  'COVID-19',
  'CPAP',
  'CPR',
  'Crew Resource Management',
  'Critical Care',
  'Critical Care Transport',
  'Critical Decision Making',
  'Culture of Safety',
  'Death',
  'Depression',
  'Diabetic Emergencies',
  'Disaster Management',
  'Diving and Hyperbarics',
  'Documentation',
  'Ebola',
  'Educator',
  'EKG Recognition',
  'Electrolyte Imbalance',
  'Emergency Child Birth',
  'Emergency Medical Dispatch (EMD)',
  'Emotional Resilience',
  'EMR Refresher Course',
  'EMS Self Defense',
  'EMT Refresher',
  'Endocrinology',
  'Envenomations',
  'Environmental Emergencies',
  'Ethics',
  'Evidence Based Guidelines',
  'Flight Physiology',
  'Fluid Resuscitation',
  'Fracture Management',
  'Geriatrics',
  'GI and GU Emergencies',
  'Gynecology',
  'Hazardous Materials',
  'Head Injuries',
  'Health and Wellness',
  'Heart Rhythms',
  'Hematology',
  'Hemorrhage Control',
  'Human Trafficking',
  'Hygiene Vaccinations',
  'Hypertension',
  'Immunology',
  'Infection Control',
  'Infectious Disease',
  'Intraosteous Infusion',
  'ITLS',
  'IV Therapy',
  'K9 Officer Care',
  'Leadership',
  'Legal',
  'LVAD',
  'Management Training',
  'Mass Violence',
  'Medical Director',
  'Medical Emergencies',
  'Medication Delivery',
  'MRSA',
  'Neonatology',
  'Neurology',
  'Nephrology',
  'Obesity',
  'Obstetrics',
  'Oncology',
  'Operations',
  'Opioids',
  'OSHA',
  'Oxygenation',
  'Pain Management',
  'PALS',
  'Paramedic Refresher',
  'Pediatric Assessment',
  'Pediatric Cardiac Arrest',
  'Pediatric Emergency Standards',
  'Pediatric Medical Emergencies',
  'Pediatric Respiratory Emergencies',
  'Pediatric Shock',
  'Pediatric Trauma',
  'Pediatrics',
  'Pharmacology',
  'Phlebotomy',
  'PHTLS',
  'Post Resuscitation Care',
  'Psychiatric Emergencies',
  'PTSD',
  'Quality Improvement',
  'Research',
  'Respiratory Emergencies',
  'Resuscitation',
  'Safety',
  'Seizures',
  'Sepsis',
  'Shock',
  'Skills',
  'Special Needs',
  'Special Topics',
  'Spinal Restriction',
  'Sports Injuries',
  'Stroke',
  'Tactical',
  'Terrorism Response',
  'Toxicology',
  'Traffic Incident Management',
  'Trauma',
  'Trauma Triage',
  'Traumatic Brain Injuries',
  'Triage',
  'Ultrasound',
  'Urology',
  'Ventilation',
  'Ventricular Assist Devices',
  'Wilderness Medicine',
]
